import { render, staticRenderFns } from "./brandTable.vue?vue&type=template&id=60d3694e&scoped=true"
import script from "./brandTable.vue?vue&type=script&lang=js"
export * from "./brandTable.vue?vue&type=script&lang=js"
import style0 from "./brandTable.vue?vue&type=style&index=0&id=60d3694e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d3694e",
  null
  
)

export default component.exports